type TrackingEventName =
    'AddOrganization'
    | 'CreateNewLicenseSystem'
    | 'RepairLicenseSystem'
    | 'MoveLicenses'
    | 'EditOrganization'
    | 'EditUserName'
    | 'InviteUser'
    | 'JoinOrganization'
    | 'RequestTemporaryLicenses'
    | 'OpenOrDownloadApp'
    | 'ConnectToManageLicenses'
    | 'EditUser'
    | 'DeleteUser'
    | 'ChangeLanguage'
    | 'EnableOffLineLicensing'
    | 'DownloadLicenseUpdate'
    | 'ChangeTheme'
    | 'ContactSupport'
    | 'CheckThirdPartyLicensing'
    | 'GoToHelpDesk';

export interface TrackingEvent {
    name: TrackingEventName;
    additionalProperties?: Record<string, string>;
}

export function checkDisableTracking(email: string | undefined, ignore: Array<string>) {
    if (!email) {
        return;
    }
    if (ignore.find(ignorePattern => email.indexOf(ignorePattern) > -1)) {
        localStorage.setItem('plausible_ignore', 'true');
    } else {
        localStorage.removeItem('plausible_ignore');
    }
}

export function getOfflineLicensing(orgId: string | undefined): TrackingEvent {
    const additionalProperties: Record<string, string> = {};
    //
    if (orgId) {
        additionalProperties.orgId = orgId;
    }

    return {
        name: 'EnableOffLineLicensing',
        additionalProperties,
    };
};
export function getCheckThirdPartyLicensingEvent(): TrackingEvent {
    return {
        name: 'CheckThirdPartyLicensing',
    };
};
export function getDonwloadLicenseUpdateEvent(): TrackingEvent {
    return {
        name: 'DownloadLicenseUpdate',
    };
};
export function getMoveLicensesEvent(): TrackingEvent {
    return {
        name: 'MoveLicenses',
    };
};
export function getCreateNewLicenseSystemEvent(): TrackingEvent {
    return {
        name: 'CreateNewLicenseSystem',
    };
};
export function getRepairLicenseSystemEvent(): TrackingEvent {
    return {
        name: 'RepairLicenseSystem',
    };
};
export function getAddOrganizationEvent(): TrackingEvent {
    return {
        name: 'AddOrganization',
    };
};

export function getEditOrganizationEvent(): TrackingEvent {
    return {
        name: 'EditOrganization',
    };
};
export function getEditUserNameEvent(): TrackingEvent {
    return {
        name: 'EditUserName',
    };
};

export function getInviteUserEvent(): TrackingEvent {
    return {
        name: 'InviteUser',
    };
};

export function getJoinOrganizationEvent(): TrackingEvent {
    return {
        name: 'JoinOrganization',
    };
};

export function getRequestTemporaryLicensesEvent(): TrackingEvent {
    return {
        name: 'RequestTemporaryLicenses',
    };
};

export function getConnectToManageLicensesEvent(): TrackingEvent {
    return {
        name: 'ConnectToManageLicenses',
    };
};

export function getOpenOrDownloadAppEvent(appName: string): TrackingEvent {
    return {
        name: 'OpenOrDownloadApp',
        additionalProperties: {
            appName,
        },
    };
};

export function getEditUserEvent(role: string, modules: Array<string>): TrackingEvent {
    return {
        name: 'EditUser',
        additionalProperties: {
            role,
            modules: JSON.stringify(modules),
        },
    };
};

export function getDeleteUserEvent(): TrackingEvent {
    return {
        name: 'DeleteUser',
    };
};

export function getChangeLanguageEvent(targetLanguage: string): TrackingEvent {
    return {
        name: 'ChangeLanguage',
        additionalProperties: {
            targetLanguage,
        },
    };
};

export function getChangeThemeEvent(targetTheme: string): TrackingEvent {
    return {
        name: 'ChangeTheme',
        additionalProperties: {
            targetTheme,
        },
    };
};

export function getContactSupportEvent(): TrackingEvent {
    return {
        name: 'ContactSupport',
    };
};

export function getGoToHelpDeskEvent(product: string): TrackingEvent {
    return {
        name: 'GoToHelpDesk',
        additionalProperties: {
            product,
        },
    };
};